import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';

import { getSpecialtyCode, getSpecialtyName } from '../utils';
import RoutingRuleSelector from './RoutingRuleSelector';
import APPLY_RULE_TO_GROUP from '../mutations/apply-rule-to-group.graphql';

const EditRoutingRule = ({ specialty, groupId, onClose }) => {
  const [selectedRule, setSelectedRule] = useState('');
  const [applyRoutingRule, { loading }] = useMutation(APPLY_RULE_TO_GROUP, {
    refetchQueries: ['routingRulesPerSpecialty']
  });

  useEffect(() => {
    if (specialty.routingRule) {
      setSelectedRule(specialty.routingRule.ruleCode);
    }
  }, [specialty]);

  const handleSave = async () => {
    const specialtyCd = getSpecialtyCode(specialty);
    await applyRoutingRule({
      variables: {
        groupId: groupId,
        ruleId: selectedRule ? Number(selectedRule) : undefined,
        specialtyCd
      }
    });
    onClose();
  };

  const isSaveButtonDisabled = (() => {
    const selectedTheSameRoutingRule =
      (specialty.routingRule && specialty.routingRule.ruleCode === selectedRule) ||
      (!specialty.routingRule && !selectedRule);

    const isUnassignForDefaultProduct = specialty.specialty === null && !selectedRule;

    if (loading || selectedTheSameRoutingRule || isUnassignForDefaultProduct) {
      return true;
    }
    return false;
  })();

  return (
    <div className="group-rule-form">
      <h4>Edit Routing Rule</h4>
      <p className="rule-name mb-3">{getSpecialtyName(specialty)}</p>
      <p className="text-gray-500	mt-4 font-semibold">Routing rule</p>
      <RoutingRuleSelector onSelectRule={setSelectedRule} selectedRule={selectedRule} />
      <div className="mt-5">
        <button onClick={onClose} className="button secondary mr-3 w-24">
          Cancel
        </button>
        <button disabled={isSaveButtonDisabled} onClick={handleSave} className="button w-24">
          Save
        </button>
      </div>
    </div>
  );
};

export default EditRoutingRule;
